// initial state
import * as base from './base.js'
const smsLogName = '/admin/api/smsLog'

const obj = base.setBaseUrl('smsLog', smsLogName)
const a = Object.assign(obj)
export default a
